// removed by extract-text-webpack-plugin
module.exports = {"deck-title":"WEOMbcpkXMuRb6iWk-Rt-","grid-figure":"_9PYreb71nBkUpB1tEaSK9","control-buttons":"_3sMmRD4zfPImk5Q-EGb4o6"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/Deck.styl
// module id = 500
// module chunks = 0